import React, { useState, useContext, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import CallIcon from '@mui/icons-material/Call';
import { selectConfig } from '../../redux/slices/configSlice';
import { RootState } from '../../redux/store';
import type { Conversation, Participant } from '@twilio/conversations';
import { externalEventService } from '../../services/externalEventService';

export default function Header() {
  const [openCloseDialog, setOpenCloseDialog] = useState(false);
  const [openCallDialog, setOpenCallDialog] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const currentPage = useSelector((state: RootState) => state.page.currentPage);




const chatMessages = useSelector((state: RootState) => state.chat.messages || []);
console.log("💬 chatMessages from Redux:", chatMessages);

  // Get Twilio conversation from Redux
  const conversation = useSelector((state: RootState) => (state as any)?.twilioChat?.conversation) as Conversation | undefined;

  const config = useSelector(selectConfig);
  const formData = config?.data?.length ? config.data[0].attributes : null;

  console.log("currentPage", currentPage)

  // Handle browser/tab close events
  useEffect(() => {
    const leaveConversation = () => {
      if (conversation) {
        console.log("🚪------------------------------------------------------ Leaving conversation due to page state change");

        try {
          conversation.leave();
        } catch (error) {
          console.error("❌ Error leaving conversation:", error);
        }
      }
    };

    const handleBeforeUnload = () => {
      console.log("🚪 Browser/tab closing - beforeunload triggered");
      leaveConversation();
    };

    const handleUnload = () => {
      if (conversation) {
        console.log('🚪 Page unloading - final attempt to leave conversation');
        // Final attempt during unload - this is synchronous
        try {
          conversation.leave();
        } catch (error) {
          console.error('❌ Error in unload leave:', error);
        }
      }
    };

    // Add event listeners for browser/tab close
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, [conversation]);

  // hide logo broken image
  const handleImageLoad = useCallback(() => {
    setLoaded(true);
  }, [])

  // Close button handlers
  const handleCloseButtonClick = () => {
    setOpenCloseDialog(true);
  };

  const notifyAgentChatClosed = async (conversationSid: string) => {
    try {
      const response = await fetch('/api/agent/notify-chat-closed', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          conversationSid,
          action: 'close_chat_card',
          timestamp: new Date().toISOString()
        })
      });
      
      if (response.ok) {
        console.log('✅ Agent notified of chat closure');
      }
    } catch (error) {
      console.error('❌ Failed to notify agent:', error);
    }
  };

  const handleConfirmLeave = async () => {
    setOpenCloseDialog(false);

    if (conversation) {
      // Notify agent first
      // await notifyAgentChatClosed(conversation.sid);
      
      // Then cleanup conversation
      await conversation.leave();
    }

    window.close();
  };

  const handleCancelLeave = () => {
    setOpenCloseDialog(false);
  };

  // Call button handlers
  const handleCallButtonClick = () => {
    setOpenCallDialog(true);
  };

  const handleConfirmCall = () => {
    setOpenCallDialog(false);

    const currentUrl = new URL(window.location.href);

    const pathParts = currentUrl.pathname.split('/').filter(part => part); // Split path into parts
    const lang = pathParts[1];
    let brand = pathParts[2];
    const sParam = currentUrl.searchParams.get('s');
    const level = currentUrl.searchParams.get('level');
    if (brand == 'dafabet') {
      brand = 'mc-desktop';
    }


    // Construct the new URL
    let navigateUrl = `https://www.cs-livechat.com/ccaas/v2/call/${brand}?lang=${lang}`;
    if (sParam) {
      navigateUrl += `&s=${sParam}`;
    }
    if (level) {
      navigateUrl = navigateUrl + "&level=" + level;
    }

    window.location.href = navigateUrl;
  };

  const handleCancelCall = () => {
    setOpenCallDialog(false);
  };

const printChat = () => {
  if (!chatMessages.length) {
    alert("No user messages to print");
    return;
  }

  const newWindow = window.open('', 'newwin', 'width=600,height=750');
  if (!newWindow) {
    alert('Unable to open a new window. Please allow pop-ups and try again.');
    return;
  }

  chatMessages.forEach((message) => {
    const isEvent = message.senderType === "PARTICIPANT_ADDED" || message.senderType === "PARTICIPANT_REMOVED";
    const timestamp = message.receivedAt || message.lastUpdatedTimestamp || Date.now();
    const formattedDate = new Date(timestamp).toLocaleString();
    const participantText = isEvent
      ? message.senderType === "PARTICIPANT_ADDED" ? "Agent joined" : "Agent left"
      : message.senderParticipantType || "Unknown";
    const messageText = message.body?.elementText?.text || message.body || "";

    newWindow.document.write(`<p><b>${participantText}</b> at ${formattedDate}</p>`);
    newWindow.document.write(`<p>${messageText}</p>`);
  });

  newWindow.document.close();
  newWindow.focus();

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (isIOS) {
    setTimeout(() => newWindow.print(), 1000);
  } else {
    newWindow.print();
    setTimeout(() => newWindow.close(), 1000);
  }
};

const brand = formData?.Template?.Brand?.toLowerCase();
const isCenteredBrand = ['zipang', 'sevenbaby', 'jamboree'].includes(brand);

  return (
    <Box
      pl={2}
      pr={2}
      sx={{
        backgroundColor: 'primary.main',
        padding: '16px',
        width: '100%',
        display: 'flex',
        justifyContent: isCenteredBrand ? 'space-between' : 'flex-start',
        alignItems: 'center',
        borderBottom: formData?.Template?.Brand.toLowerCase() === 'zipang' ? '5px solid #db1919' : 'none',
      }}
    >
  {!isCenteredBrand && (
    <Box
      component="img"
      sx={{
        height: 'auto',
        maxWidth: '200px',
      }}
      alt={formData?.Template?.BrandLogoMobile?.data?.attributes?.alternativeText || "Logo image"}
      src={formData?.Template?.BrandLogoMobile?.data?.attributes?.url || ""}
      style={{ visibility: loaded ? 'visible' : 'hidden', opacity: loaded ? 1 : 0 }}
      onLoad={handleImageLoad}
    />
  )}
    {isCenteredBrand && (
    <Box
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
      }}
    >
      <Box
        component="img"
        sx={{
          maxWidth: '200px',
          height: 'auto',
        }}
        alt={formData?.Template?.BrandLogoMobile?.data?.attributes?.alternativeText || "Logo image"}
        src={formData?.Template?.BrandLogoMobile?.data?.attributes?.url || ""}
        style={{ visibility: loaded ? 'visible' : 'hidden', opacity: loaded ? 1 : 0 }}
        onLoad={handleImageLoad}
      />
    </Box>
  )}

      <Box
        sx={{
          display: 'flex',
          gap: 1,
          marginLeft: 'auto',
        }}
      >

        {currentPage === 'chat' && !formData?.Template?.HidePrint && (
          <>
            <Button
              variant="outlined"
              sx={{
                color: 'secondary.light',
                border: '3px solid',
                borderRadius: '50%',
                minWidth: 'auto',
                width: '35px',
                height: '35px',
              }}
              onClick={printChat}
              title={formData?.Template?.PrintTooltip}
              disabled={!chatMessages?.length}
            >
              <PrintIcon />
            </Button>

            {(formData.CallUs?.EnableCallUsButton) ?
              <Button
                variant="outlined"
                sx={{
                  color: 'secondary.light',
                  border: '3px solid',
                  borderRadius: '50%',
                  minWidth: 'auto',
                  width: '35px',
                  height: '35px',
                }}
                onClick={handleCallButtonClick}
                title={formData?.Template?.CallUsTooltip ?? "call"}
              >
                <CallIcon />
              </Button>
              : null}
          </>
        )}

        { (formData?.Tooltips?.HideCloseButton) ?
          null : <Button
            variant="outlined"
            sx={{
              color: 'secondary.light',
              border: '3px solid',
              borderRadius: '50%',
              minWidth: 'auto',
              width: '35px',
              height: '35px',
            }}
            onClick={handleCloseButtonClick}
            title={formData?.Template?.PrintTooltip ?? "close"}
          >
            <CloseIcon />
          </Button> }
      </Box>

      {/* Close Confirmation Dialog */}
      <Dialog
        open={openCloseDialog}
        onClose={handleCancelLeave}
        aria-labelledby="close-dialog-title"
        aria-describedby="close-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            width: '400px', // Set a consistent width
          },
        }}
      >
        <DialogTitle id="close-dialog-title">{formData?.LeaveChat?.LeaveChatConfirmationTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="close-dialog-description">
            {formData?.LeaveChat?.LeaveChatConfirmation}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelLeave} color="primary">
            {formData?.LeaveChat?.No}
          </Button>
          <Button onClick={handleConfirmLeave} color="secondary" autoFocus>
            {formData?.LeaveChat?.Yes}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Call Confirmation Dialog */}
      <Dialog
        open={openCallDialog}
        onClose={handleCancelCall}
        aria-labelledby="call-dialog-title"
        aria-describedby="call-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            width: '400px', // Set a consistent width
          },
        }}
      >
        <DialogTitle id="call-dialog-title">{formData?.LeaveChat?.CallConfirmationTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="call-dialog-description">
            {formData?.LeaveChat?.LeaveChatConfirmation}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelCall} color="primary">
            {formData?.LeaveChat?.No}
          </Button>
          <Button onClick={handleConfirmCall} color="secondary" autoFocus>
            {formData?.LeaveChat?.Yes}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
